import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {ConsoleLogger} from '../shared/console-logger';

@Injectable({
  providedIn: 'root'
})
export class AppIdGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    ConsoleLogger.debug('AppIdGuard.canActivate(): ' + state.url);
    // Check for appId in URL query parameters
    const appIdFromUrl = route.queryParamMap.get('appId');

    // Fallback to localStorage if not in URL
    const appIdFromStorage = !appIdFromUrl ? localStorage.getItem('district_appId') : null;

    // Determine if we have a valid appId from either source
    const hasAppId = !!(appIdFromUrl || appIdFromStorage);

    if (!hasAppId) {
      // Redirect to missing-app-id page if no appId found
      return this.router.createUrlTree(['/error', 'missing-app-id']);
    }

    // Allow navigation if appId exists
    return true;
  }
}
